export const defaultDuration = 7; // number of days duration
export const showSelectedEmployeeInFilterList = true; // after assigining employee to shift hide / show in list
export const dayBeginsHour = 0; // TimeStart
export const businessEndsHour = 24;
export const businessBeginsHour = 7;
export const defaultMonthlyHours = 160;
